import { CommonModule as NgCommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-card',
    standalone: true,
    imports: [NgCommonModule, TranslateModule],
    templateUrl: './app-card.component.html'
})
export class AppCardComponent {
    @Input() title: string;
    @Input() nrOfActiveFilters: number;
    @Input() hostClass: string;
    @Input() contentClass: string;
}
